module.exports = __webpack_public_path__ + "img/IMG_5888.71b8f41a.jpg";